var serviceRequestTable;

function InitServiceRequestDataTable(dateFormat) {

    document.documentElement.style.setProperty('--toolbelt-loadingbar-color', 'transparent')

        if (serviceRequestTable != null) {
            try {
                serviceRequestTable.destroy();
                serviceRequestTable = null;
            } catch (e) {

            }
        }

        serviceRequestTable = $('#serviceRequestViewList').DataTable({
            "order": [[2, "desc"]],
            pageLength: 25,
            autoWidth: false,
            "columnDefs": [
                { "width": "122px", "targets": 0 }, //ServiceRequest #
                { "width": "186px", "targets": 1 }, //Placed
                { "width": "100px", "targets": 2 }, //Unit
                { "width": "100px", "targets": 3 }, //Location
                { "width": "118px", "targets": 4 }, //Title
                { "width": "345px", "targets": 5 }, //Description
                { "width": "64px", "targets": 6 }, //Follow up needed
                { "width": "128px", "targets": 7 } //Category list
            ],
            "language": {
                "emptyTable": "There are currently no service requests. Create a new service request with the button in the top right",
                "info": "Showing _START_ to _END_ of _TOTAL_ service requests",
                "infoEmpty": "Showing 0 to 0 of 0 service requests",
                "infoFiltered": "(filtered from _MAX_ total service requests)",
                "lengthMenu": "Show _MENU_ service requests"
            },
            columns: [
                {
                    data: 'serviceRequestNumber',

                },
                {
                    data: 'created',
                    render: function (data, type) {
                        if (type === 'display') {
                            if (dateFormat == 0) {
                                return timestampToJexcelDate(data);}
                            else {
                                return timestampToUsDate(data);
                            }
                            
                           
                        }

                        return data;
                    }
                },
                {
                    data: 'unit'
                },
                {
                    data: 'location'
                },
                {
                    data: "title"
                },
                {
                    data: "text"
                },
                {
                    data: 'followUpNeeded',
                    render: function (data, type) {
                        if (type === 'display') {
                            if (data == true) {
                                return "yes";
                            }
                            else {
                                return "no";
                            }
                        }

                        return data;
                    }
                    //render: function (data, type, row, meta) {
                    //    return type === 'display' ?
                    //        '<progress value="' + data + '" max="9999"></progress>' :
                    //        data;
                    //}
                },
                {
                    data: 'typeCategoryList',
                    render: function (data, type) {
                        if (type === 'display') {
                            try {
                                var categories = data.split(";");
                                var displayText = categories.filter(function (val) { return val; }).join(', ');
                                return displayText;

                            } catch {}
                           
                        }

                        return data;
                    }
                    //render: function (data, type, row, meta) {
                    //    return type === 'display' ?
                    //        '<progress value="' + data + '" max="9999"></progress>' :
                    //        data;
                    //}
                },
                //{
                //    data: 'priority',
                //    render: function (data, type) {
                //        if (type === 'display') {

                //            if (data == 3) {
                //                return '<strong><span style="color:red;">Critical</span></strong>';
                //            } else if (data == 2){
                //                return '<span>High</span>';
                //            }
                //            else if (data == 1) {
                //                return '<span>Medium</span>';
                //            }
                //            else if (data == 0) {
                //                return '<span>Low</span>';
                //            }

                //            return "";
                //        }

                //        return data;
                //    }
                //}
            ]
        });

        $('#serviceRequestViewList tbody').on('click', 'tr', function () {
            var data = serviceRequestTable.row(this).data();
            console.log(data);

            var serviceRequestNumberParsed = -1;

            try {
                serviceRequestNumberParsed = parseInt(data.serviceRequestNumber);
            } catch (e) {

            }

            if (serviceRequestNumberParsed > 0) {
                console.log("serviceRequestNumberParsed:" + serviceRequestNumberParsed);
                DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnServiceRequestClickedFromGrid', serviceRequestNumberParsed);
            }

       
            
        });

        $("#serviceRequestViewList tr").css('cursor', 'pointer');

   // });
}

function FilterServiceRequestDataTableOnAssignedTo(assignedToName) {
    if (serviceRequestTable != null) {
        serviceRequestTable.columns(6).search(assignedToName).draw();
    }
    
}

function RemoveAssignedToFilterServiceRequestDataTable(arg) {
    if (serviceRequestTable != null) {
        serviceRequestTable.columns(6).search('').draw();
    }
    
}

function PopulateToServiceRequestDataTable(rows) {

    var serviceRequests = [];

    rows.forEach(row => serviceRequests.push({
        serviceRequestNumber: row.serviceRequestId,
        unit: row.serviceRequestUnit,
        location: row.serviceRequestLocation,
        created: new Date(row.serviceRequestTimestamp),
        duedate: row.serviceRequestDueDate == null ? null : new Date(row.serviceRequestDueDate),
        priority: row.serviceRequestPriority,
        typeCategoryList: row.serviceRequestTypeCategoryList,
        title: row.serviceRequestTitle,
        followUpNeeded: row.serviceRequestFollowUpNeeded,
        assignedTo: row.serviceRequestAssignedTo,
        unit: row.serviceRequestReceiverUnit,
        text: row.serviceRequestText
    }));

  //  serviceRequests = serviceRequests.reverse();

    console.log("serviceRequests");
    console.log(serviceRequests);

    try {
        serviceRequestTable.rows().remove()
    } catch (e) {
        console.log(e);
    }


    try {
        serviceRequestTable.rows.add(serviceRequests);
        serviceRequestTable.draw();

    } catch (e) {
        console.log(e);
    }

}

function ReloadServiceRequestDataTable(row) {

    console.log("reloading table..");
    if (serviceRequestTable != null) {
        console.log("destroying table..");
        serviceRequestTable.destroy();
        setTimeout(function () {
            console.log("buuilding table..");
            InitServiceRequestDataTable();
        }, 2000);
    }

    //  serviceRequestTable.row.add([row.serviceRequestEventServiceRequestId, row.serviceRequestEventState, 'Edinburgh']);

    //$(document).ready(function () {
    //    //$('#example').DataTable().destroy();
    //    console.log("creating new table2");
    //   // $('#example').DataTable();

    //    //serviceRequestTable.clear();
    //    var data = serviceRequestTable.data();
    //    serviceRequestTable.draw();
    //});
}


function ForceStateSelectIndex(valueToSelect) {
    var element = document.getElementById("serviceRequestDetailViewStateSelect");
    element.value = valueToSelect;
}

function ForcePrioritySelectIndex(valueToSelect) {
    var element = document.getElementById("serviceRequestDetailViewPrioritySelect");
    element.value = valueToSelect;
}


function InitServiceRequestViewGuardsTypeahead(guards) {

    var guardsRaw = [];

    var count = guards.length;
    for (var i = 0; i < count; i++) {
        var name = guards[i].guardName;
        if (name !== "") {
            guardsRaw.push(name);
        }
    }

    console.log(guardsRaw);

    $(document).ready(function () {
        buildTypeahead('#guardServiceRequestViewSelect .typeahead', "guards", guardsRaw);
    });

    

    return true;
}

function InitServiceRequestViewAssignedToGuardsTypeahead(guards) {

    var guardsRaw = [];

    var count = guards.length;
    for (var i = 0; i < count; i++) {
        var name = guards[i].guardName;
        if (name !== "") {
            guardsRaw.push(name);
        }
    }

    console.log(guardsRaw);

    $(document).ready(function () {
        buildTypeahead('#guardAssignedToServiceRequestViewSelect .typeahead', "guards", guardsRaw);
    });



    return true;
}

function InitServiceRequestViewResidentsTypeahead(people) {

    var peopleRaw = [];

    var count = people.length;
    for (var i = 0; i < count; i++) {
        var name = people[i].receiverName;
        var unit = people[i].receiverUnit;
        var phone = people[i].receiverPhonenumber;
        var email = people[i].receiverEmail;
        if (name !== "") {
            peopleRaw.push(unit + ", " + name);
        }
    }

    buildTypeahead('#residentServiceRequestViewSelect .typeahead', "people", peopleRaw);

    return true;
}

function InitServiceRequestViewVendorsTypeahead(vendors) {

    var vendorsRaw = [];

    var count = vendors.length;
    for (var i = 0; i < count; i++) {
        var name = vendors[i].vendorName;
        if (name !== "") {
            vendorsRaw.push(name);
        }
    }

    console.log("vendors raw");
    console.log(vendorsRaw);

    $(document).ready(function () {
        buildTypeahead('#vendorsServiceRequestViewSelect .typeahead', "vendors", vendorsRaw);
    });



    return true;
}

function InitServiceRequestViewVendorsAssignedtoTypeahead(vendors) {

    var vendorsRaw = [];

    var count = vendors.length;
    for (var i = 0; i < count; i++) {
        var name = vendors[i].vendorName;
        if (name !== "") {
            vendorsRaw.push(name);
        }
    }

    console.log("vendors raw");
    console.log(vendorsRaw);

    $(document).ready(function () {
        buildTypeahead('#vendorsAssignedToServiceRequestViewSelect .typeahead', "vendors", vendorsRaw);
    });



    return true;
}


//////

var serviceRequestDueDateRangePickerElementId = 'serviceRequestDueDateRangePickerViewer';
var serviceRequestDueDateRangePickerStartSelected = '';

var lastServiceRequestViewDateRangeValueShown = null;

function buildServiceRequestDueDateRangePickers(dateFormat, startDate) {

    $(document).ready(function () {

        $('#' + serviceRequestDueDateRangePickerElementId).on('apply.daterangepicker', function (ev, picker) {
            console.log("clicked apply setting date");
            // alert("New date range selected: '" + picker.startDate.format('YYYY-MM-DD') + "' to '" + picker.endDate.format('YYYY-MM-DD') + "'");

            //console.log(start);
            //console.log(start.date());
            //console.log(start.month());
            //console.log(start.year());
           // serviceRequestDueDateRangePickerStartSelected = start.toISOString();
            var start = picker.startDate;
            serviceRequestDueDateRangePickerStartSelected = start.toISOString();

            console.log(dateFormat);
            //dateFormat == 0 ? 'DD/MM/YYYY' : 'MM/DD/YYYY'
            var resultDate = '';

            if (dateFormat == 0) {
                resultDate = n2(start.date()) + "/" + n2(start.month() + 1) + "/" + start.year();
            } else {
                resultDate = n2(start.month() + 1) + "/" + n2(start.date()) + "/" + start.year();
            }

            document.getElementById('serviceRequestDueDateRangePickerViewer').value = resultDate;

            console.log(serviceRequestDueDateRangePickerStartSelected);

        });

        $('#' + serviceRequestDueDateRangePickerElementId).on('cancel.daterangepicker', function (ev, picker) {
            console.log("clicked cancel setting date");
            // alert("New date range selected: '" + picker.startDate.format('YYYY-MM-DD') + "' to '" + picker.endDate.format('YYYY-MM-DD') + "'");
            document.getElementById('serviceRequestDueDateRangePickerViewer').value = '';
       

        });

       

        $('#' + serviceRequestDueDateRangePickerElementId).on('show.daterangepicker', function (ev, picker) {

            console.log(picker.container[0]);

            $(picker.container[0]).find('.drp-buttons .cancelBtn').text("Reset");
            //console.log(elx);

            //$($(picker.container[0]).find('.drp-buttons .cancelBtn')).each(function (i, obj) {
            //    console.log(obj);
             
            //});

            var currentValue = document.getElementById('serviceRequestDueDateRangePickerViewer').value;
            lastServiceRequestViewDateRangeValueShown = currentValue;
        });

        $('#' + serviceRequestDueDateRangePickerElementId).on('hide.daterangepicker', function (ev, picker) {
            //$('#book_date').val('');
            //console.log("clicked outside setting date to empty");
            //document.getElementById('serviceRequestDueDateRangePickerViewer').value = '';

            if (lastServiceRequestViewDateRangeValueShown != null) {
                document.getElementById('serviceRequestDueDateRangePickerViewer').value = lastServiceRequestViewDateRangeValueShown;
                lastServiceRequestViewDateRangeValueShown = null;
            }

        });


    });

    $(document).ready(function () {
        $('#' + serviceRequestDueDateRangePickerElementId).daterangepicker({
            singleDatePicker: true,
            timePicker: false,
            startDate: moment().add(0, 'day')
        }, function (start, end, label) {

            //console.log(start);
            //console.log(start.date());
            //console.log(start.month());
            //console.log(start.year());
            //serviceRequestDueDateRangePickerStartSelected = start.toISOString();

            //console.log(dateFormat);
            ////dateFormat == 0 ? 'DD/MM/YYYY' : 'MM/DD/YYYY'
            //var resultDate = '';

            //if (dateFormat == 0) {
            //    resultDate = n2(start.date()) + "/" + n2(start.month() + 1) + "/" + start.year();
            //} else {
            //    resultDate = n2(start.month() + 1) + "/" + n2(start.date()) + "/" + start.year();
            //}

            //document.getElementById('serviceRequestDueDateRangePickerViewer').value = resultDate;
         
            //console.log(serviceRequestDueDateRangePickerStartSelected);

        });

    });
}

function setServiceRequestDueDateRangerPickerDate(date) {
    try {
        var dateToSet = new Date(date);
        $('#' + serviceRequestDueDateRangePickerElementId).data('daterangepicker').setStartDate(dateToSet);
        $('#' + serviceRequestDueDateRangePickerElementId).data('daterangepicker').setEndDate(dateToSet);
    } catch (e) {
        console.log(e);
    }
}


function getServiceRequestDueDateRangePickerStartSelected() {
    return serviceRequestDueDateRangePickerStartSelected;
}

//////



//////

var serviceRequestBoardApprovalDateRangePickerElementId = 'serviceRequestBoardApprovalDateRangePickerViewer';
var serviceRequestBoardApprovalDateRangePickerStartSelected = '';

var lastServiceRequestViewBoardApprovalDateRangeValueShown = null;

function buildServiceRequestBoardApprovalDateRangePickers(dateFormat, startDate) {

    $(document).ready(function () {
        $('#' + serviceRequestBoardApprovalDateRangePickerElementId).on('apply.daterangepicker', function (ev, picker) {
            console.log("clicked apply setting date");

            var start = picker.startDate;
            serviceRequestBoardApprovalDateRangePickerStartSelected = start.toISOString();

            console.log(dateFormat);
            //dateFormat == 0 ? 'DD/MM/YYYY' : 'MM/DD/YYYY'
            var resultDate = '';

            if (dateFormat == 0) {
                resultDate = n2(start.date()) + "/" + n2(start.month() + 1) + "/" + start.year();
            } else {
                resultDate = n2(start.month() + 1) + "/" + n2(start.date()) + "/" + start.year();
            }

            document.getElementById('serviceRequestBoardApprovalDateRangePickerViewer').value = resultDate;

            console.log(serviceRequestBoardApprovalDateRangePickerStartSelected);

        });

        $('#' + serviceRequestBoardApprovalDateRangePickerElementId).on('cancel.daterangepicker', function (ev, picker) {
            console.log("clicked cancel setting date");
            document.getElementById('serviceRequestBoardApprovalDateRangePickerViewer').value = '';
        });

        $('#' + serviceRequestBoardApprovalDateRangePickerElementId).on('show.daterangepicker', function (ev, picker) {

            console.log(picker.container[0]);

            $(picker.container[0]).find('.drp-buttons .cancelBtn').text("Reset");

            var currentValue = document.getElementById('serviceRequestBoardApprovalDateRangePickerViewer').value;
            lastServiceRequestViewBoardApprovalDateRangeValueShown = currentValue;
        });

        $('#' + serviceRequestBoardApprovalDateRangePickerElementId).on('hide.daterangepicker', function (ev, picker) {

            if (lastServiceRequestViewBoardApprovalDateRangeValueShown != null) {
                document.getElementById('serviceRequestBoardApprovalDateRangePickerViewer').value = lastServiceRequestViewBoardApprovalDateRangeValueShown;
                lastServiceRequestViewBoardApprovalDateRangeValueShown = null;
            }

        });


    });

    $(document).ready(function () {

        try {
            $('#' + serviceRequestBoardApprovalDateRangePickerElementId).daterangepicker({
                singleDatePicker: true,
                timePicker: false,
                startDate: moment().add(0, 'day')
            }, function (start, end, label) {

            });

        } catch (e) {
            console.log(e);
        }
    });
}

function setServiceRequestBoardApprovalDateRangerPickerDate(date) {
    try {
        var dateToSet = new Date(date);
        $('#' + serviceRequestBoardApprovalDateRangePickerElementId).data('daterangepicker').setStartDate(dateToSet);
        $('#' + serviceRequestBoardApprovalDateRangePickerElementId).data('daterangepicker').setEndDate(dateToSet);
    } catch (e) {
        console.log(e);
    }
}


function getServiceRequestBoardApprovalDateRangePickerStartSelected() {
    return serviceRequestBoardApprovalDateRangePickerStartSelected;
}

//////

//////

var serviceRequestCompletedOnDateRangePickerElementId = 'serviceRequestCompletedOnDateRangePickerViewer';
var serviceRequestCompletedOnDateRangePickerStartSelected = '';

var lastServiceRequestViewCompletedOnDateRangeValueShown = null;

function buildServiceRequestCompletedOnDateRangePickers(dateFormat, startDate) {

    $(document).ready(function () {
        $('#' + serviceRequestCompletedOnDateRangePickerElementId).on('apply.daterangepicker', function (ev, picker) {
            console.log("clicked apply setting date");

            var start = picker.startDate;
            serviceRequestCompletedOnDateRangePickerStartSelected = start.toISOString();

            console.log(dateFormat);
            //dateFormat == 0 ? 'DD/MM/YYYY' : 'MM/DD/YYYY'
            var resultDate = '';

            if (dateFormat == 0) {
                resultDate = n2(start.date()) + "/" + n2(start.month() + 1) + "/" + start.year();
            } else {
                resultDate = n2(start.month() + 1) + "/" + n2(start.date()) + "/" + start.year();
            }

            document.getElementById('serviceRequestCompletedOnDateRangePickerViewer').value = resultDate;

            console.log(serviceRequestCompletedOnDateRangePickerStartSelected);

        });

        $('#' + serviceRequestCompletedOnDateRangePickerElementId).on('cancel.daterangepicker', function (ev, picker) {
            console.log("clicked cancel setting date");
            document.getElementById('serviceRequestCompletedOnDateRangePickerViewer').value = '';
        });

        $('#' + serviceRequestCompletedOnDateRangePickerElementId).on('show.daterangepicker', function (ev, picker) {

            console.log(picker.container[0]);

            $(picker.container[0]).find('.drp-buttons .cancelBtn').text("Reset");

            var currentValue = document.getElementById('serviceRequestCompletedOnDateRangePickerViewer').value;
            lastServiceRequestViewCompletedOnDateRangeValueShown = currentValue;
        });

        $('#' + serviceRequestCompletedOnDateRangePickerElementId).on('hide.daterangepicker', function (ev, picker) {

            if (lastServiceRequestViewCompletedOnDateRangeValueShown != null) {
                document.getElementById('serviceRequestCompletedOnDateRangePickerViewer').value = lastServiceRequestViewCompletedOnDateRangeValueShown;
                lastServiceRequestViewCompletedOnDateRangeValueShown = null;
            }

        });


    });

    $(document).ready(function () {

        try {
            $('#' + serviceRequestCompletedOnDateRangePickerElementId).daterangepicker({
                singleDatePicker: true,
                timePicker: false,
                startDate: moment().add(0, 'day')
            }, function (start, end, label) {

            });

        } catch (e) {
            console.log(e);
        }
    });
}

function setServiceRequestCompletedOnDateRangerPickerDate(date) {
    try {
        var dateToSet = new Date(date);
        $('#' + serviceRequestCompletedOnDateRangePickerElementId).data('daterangepicker').setStartDate(dateToSet);
        $('#' + serviceRequestCompletedOnDateRangePickerElementId).data('daterangepicker').setEndDate(dateToSet);
    } catch (e) {
        console.log(e);
    }
}


function getServiceRequestCompletedOnDateRangePickerStartSelected() {
    return serviceRequestCompletedOnDateRangePickerStartSelected;
}

//////

function maintenanceServiceRequestDone(maintenanceServiceRequestId, el) {

    //var buttonElementId = "maintenanceServiceRequestDoneButton-" + maintenanceServiceRequestId;

    //console.log("buttonElementId: " + buttonElementId);

    var buttonElement = el;

    console.log("buttonElement to set animation");
    console.log(buttonElement);


    $(buttonElement).addClass("slide_right_done");
    //buttonElement.classList.add('slide_right_done');

   // buttonElement.innerHTML = "DONE";



    DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnMaintenanceServiceRequestClickedDoneFromGrid', maintenanceServiceRequestId);

    setTimeout(function () {

       
       

        console.log("click event btn");
        console.log(buttonElement);

      //  $(".button_slide").removeClass("slide_right_done");


    }, 1000);


   
}

function removeAllDoneButtonAnimations(arg) {
    $(".button_slide").removeClass("slide_right_done");
}

//function (el, overdue, ooingng) {

//    setTimeout(function () {
//        tippy('#' + el, {
//            arrow: false,
//            content: '<span>' + 'A VisitForm Ultimate license is required to send texts.' + '</span>',
//            allowHTML: true
//        });
//    }, 3500);

//}

function createMaintenanceServiceRequestStatusTooltip(el, overdue, ongoing, endsSoon) {

    var text = "Done and on schedule";

    if (overdue) {
        text = "Overdue and to be done as soon as possible";
    }
    else if (ongoing) {
        if (endsSoon) {
            text = "Due in less than one hour";
        }
        else {
            text = "Planned time passed and should be done before due date";
        }
        
    }

    setTimeout(function () {
        tippy('#' + el, {
            content: '<span>' + text + '</span>',
            allowHTML: true
        });
    }, 1500);

}


function createMaintenanceServiceRequestTooltip(el, text) {


    setTimeout(function () {
        tippy(el, {
            content: '<span>' + text + '</span>',
            allowHTML: true
        });
    }, 1500);

}

function showMaintenanceServiceRequestModalInfo(maintenanceServiceRequest) {

    console.log("maintenanceServiceRequest");
    console.log(maintenanceServiceRequest);

    document.getElementById('showMaintenanceServiceRequestModalTitle').innerHTML = maintenanceServiceRequest.maintenanceServiceRequestTitle;

    //

    if (maintenanceServiceRequest.maintenanceServiceRequestIntervalDescription) {
        document.getElementById('showMaintenanceServiceRequestModalIntervalDescription').innerHTML = maintenanceServiceRequest.maintenanceServiceRequestIntervalDescription;
        $('#showMaintenanceServiceRequestModalIntervalDescriptionLabel').show();
    }
    else {
        document.getElementById('showMaintenanceServiceRequestModalIntervalDescription').innerHTML = "";
        $('#showMaintenanceServiceRequestModalIntervalDescriptionLabel').hide();
    }

    //

    if (maintenanceServiceRequest.maintenanceServiceRequestDescriptionHelpInfo) {

        var helpInfoMessageText = maintenanceServiceRequest.maintenanceServiceRequestDescriptionHelpInfo;

        try {
            helpInfoMessageText = helpInfoMessageText.replace(/\n/g, '<br>');
        }
        catch {

        }


        document.getElementById('showMaintenanceServiceRequestModalDescriptionHelpInfo').innerHTML = helpInfoMessageText;
        $('#showMaintenanceServiceRequestModalDescriptionHelpInfoLabel').show();
    }
    else {
        document.getElementById('showMaintenanceServiceRequestModalDescriptionHelpInfo').innerHTML = "";
        $('#showMaintenanceServiceRequestModalDescriptionHelpInfoLabel').hide();
    }


    //

    if (maintenanceServiceRequest.maintenanceServiceRequestDescription) {
        document.getElementById('showMaintenanceServiceRequestModalDescription').innerHTML = maintenanceServiceRequest.maintenanceServiceRequestDescription;
        $('#showMaintenanceServiceRequestModalDescriptionLabel').show();
    }
    else {
        document.getElementById('showMaintenanceServiceRequestModalDescription').innerHTML = "";
        $('#showMaintenanceServiceRequestModalDescriptionLabel').hide();
    }

    //
   
    $('#showMaintenanceServiceRequestInfoModal').modal();

}




function uploadServiceRequestImage(arg, inputid, screenid, blobidentifier) {

  
    var url = 'https://visitform.com/app/api/Image/serviceRequestimageupload/';
    if (release == false) {
        url = 'https://localhost:5001/api/Image/serviceRequestimageupload/';
    }

    var file_data = $('#' + inputid).prop('files')[0];
    console.log(file_data);
    var form_data = new FormData();
    form_data.append('file', file_data);
    $.ajax({
        url: url + screenid + "/" + blobidentifier,
        dataType: 'text',
        cache: false,
        contentType: false,
        processData: false,
        data: form_data,
        type: 'post',
        beforeSend: function (xhr) {   //Include the bearer token in header
            xhr.setRequestHeader("Authorization", 'Bearer ' + arg);
        },
        success: function (response) {
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnServiceRequestImageUploadDoneFromAjax', blobidentifier, 201);
        },
        error: function (response) {
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnServiceRequestImageUploadDoneFromAjax', blobidentifier, 500);
        }
    });
    //  });
}

function StartServiceRequestImageUpload() {

    $("#serviceRequestReadFileInput").click();
}

function FileChosenServiceRequest(e) {

    try {
        var fileName = $('#inputGroupFile01').prop('files')[0].name;
       // document.getElementById('chosenFileLabel').innerHTML = fileName;
    } catch (e) {

    }


}

function serviceRequestDisplayImage(checkinId, blobIdentifier) {
    DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnDashboardShowPhotoOpenedByUser', checkinId, blobIdentifier);
}


function openServiceRequestDisplayImageModal(arg) {
    $('#serviceRequestShowPhotoModal').modal();
}

